/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-11-23 14:10:53
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Button, Popover, ActionList } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import history from 'src/routes/history';
import { routes } from 'src/routes';
import { getShop } from 'src/helpers';

type State = {
  active: boolean
};
type Props = {
  searchTerm: string
};

type ComposedProps = Props & WithI18nProps;
class PopoverActionButton extends Component<ComposedProps, State> {
  handleAddRuleMerchandising = () => {
    history.push(routes.merchandising.view());
  };

  handleAddSynonym = () => {
    const { searchTerm, tenantApp = {} } = this.props;
    const enableAutofillSearchTermSynonym = _.get(
      tenantApp,
      'settings.analyticV2.settings.enableAutofillSearchTermSynonym',
      false
    );
    if (enableAutofillSearchTermSynonym) {
      try {
        localStorage.setItem(`${getShop()}-synonym-search-term`, searchTerm);
      } catch (error) {}
    }

    history.push(routes.synonym.view());
  };

  state = {
    active: false,
    menuItems: {
      merchandising: {
        content: this.props.i18n.translate(
          'AdminHTML.Analytics.SearchAnalyticsAction.add_RuleMerchandising'
        ),
        onAction: this.handleAddRuleMerchandising
      },
      synonym: {
        content: this.props.i18n.translate('AdminHTML.Analytics.SearchAnalyticsAction.add_Synonym'),
        onAction: this.handleAddSynonym
      }
    }
  };

  render() {
    const { i18n, itemsMenu = ['merchandising', 'synonym'] } = this.props;
    const { active } = this.state;

    const menuItems = itemsMenu.map(key => this.state.menuItems[key]);

    return (
      <Popover
        active={active}
        activator={
          <Button onClick={this.toggleActive} disclosure>
            {i18n.translate('AdminHTML.Analytics.SearchAnalyticsAction.add')}
          </Button>
        }
        onClose={this.toggleActive}>
        <ActionList actionRole="menuitem" items={menuItems} />
      </Popover>
    );
  }

  toggleActive = () => {
    this.setState({
      active: !this.state.active
    });
  };
}

export default withI18n()(PopoverActionButton);
